<template>
    <div class="bottom-footer">
        <span>AI赋能平台 . </span>
        <a href="https://workeredu.cn/">中国职工教育网</a>
        <!-- <span> . </span>
        <a href="">联系我们</a> -->
        <span> . </span>
        <a href="">隐私政策</a>
    </div>
</template>

<script> 

export default {
    components: {},
};
</script>
<style scoped lang="scss">
$s1024: 0.8;
$s750: 1;
.bottom-footer {
    background-color: #cd1c26;
    padding: 0.2rem 0;
    color: #fff;
    font-size: 0.18rem;
    text-align: center;
    line-height: 1.5;
    @media screen and (max-width: 1024px) {
        padding: (0.2rem * $s1024) 0;
        font-size: (0.18rem * $s1024);
    }
    @media screen and (max-width: 750px) {
        padding: (0.2rem * $s750) 0;
        font-size: (0.18rem * $s750);
    }
    a,
    a:hover,
    a:visited {
        color: #fff;
        text-decoration: none;
    }
}
</style>